/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanAddFixedCostRequestDto
 */
export interface MonthPlanAddFixedCostRequestDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanAddFixedCostRequestDto
   */
  fundId: string;
}

export function MonthPlanAddFixedCostRequestDtoFromJSON(json: any): MonthPlanAddFixedCostRequestDto {
  return MonthPlanAddFixedCostRequestDtoFromJSONTyped(json, false);
}

export function MonthPlanAddFixedCostRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanAddFixedCostRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundId: json["fundId"],
  };
}

export function MonthPlanAddFixedCostRequestDtoToJSON(value?: MonthPlanAddFixedCostRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundId: value.fundId,
  };
}
